import Axios, { AxiosRequestConfig } from "axios";
import qs from "qs";

export const ApiBaseRequestConfig: AxiosRequestConfig = {
  baseURL: `${window.location.origin}/${window.GLOBAL.API_BASE}/`,
  paramsSerializer: (params: Object) => {
    const cleanParams = Object.keys(params).reduce((buffer, current) => {
      if (typeof params[current] !== "undefined" || params[current] !== null) {
        buffer[current] = params[current];
      }
      return buffer;
    }, {});
    return qs.stringify(cleanParams, { arrayFormat: "comma", encode: false });
  },
};

export const axios = Axios.create(ApiBaseRequestConfig);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  // to parse JSON in response body for failed requests for any Blob
  (error) => {
    if (
      error.response &&
      error.request &&
      error.request.responseType === "blob" &&
      error.response.data instanceof Blob &&
      error.response.data.type &&
      error.response.data.type.toLowerCase().indexOf("json") !== -1
    ) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          error.response.data = JSON.parse(reader.result as string);
          resolve(Promise.reject(error));
        };

        reader.onerror = () => {
          reject(error);
        };

        reader.readAsText(error.response.data);
      });
    }
    return Promise.reject(error);
  }
);
